/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

let purchaseType = "buy-now";

(function () {
  // Add custom code below this line
  let cartDrawerOpenAttempts = 0;
  const CART_DRAWER_PARAM = "cart_drawer";

  const currentPageCartHref = () => {
    const url = new URL(window.location.href);
    const cartPath = ((window.theme && theme.routes && theme.routes.cart_url) || "/cart")
      .replace(/\/$/, "");
    const path = (url.pathname.replace(/\/$/, "") || "/");
    if (path === cartPath) {
      url.pathname = (window.theme && theme.routes && theme.routes.root) || "/";
    }
    url.searchParams.set(CART_DRAWER_PARAM, "open");
    return url.pathname + url.search + url.hash;
  };

  const syncCartButtonHrefs = () => {
    document.querySelectorAll("a[data-cart-toggle]").forEach((link) => {
      link.setAttribute("href", currentPageCartHref());
    });
  };

  const openRedirectedCartDrawer = () => {
    const url = new URL(window.location.href);

    if (url.searchParams.get(CART_DRAWER_PARAM) !== "open") return;

    if (window.cart && typeof window.cart.openCartDrawer === "function") {
      window.cart.openCartDrawer();
      url.searchParams.delete(CART_DRAWER_PARAM);
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
      syncCartButtonHrefs();
      return;
    }

    cartDrawerOpenAttempts += 1;

    if (cartDrawerOpenAttempts < 20) {
      window.setTimeout(openRedirectedCartDrawer, 100);
    }
  };

  const bindCartButtonNewTab = () => {
    const updateFromEvent = (e) => {
      const link = e.target && e.target.closest && e.target.closest("a[data-cart-toggle]");
      if (!link) return;
      link.setAttribute("href", currentPageCartHref());
    };

    document.addEventListener("pointerdown", updateFromEvent, true);
    document.addEventListener("contextmenu", updateFromEvent, true);
    document.addEventListener(
      "click",
      (e) => {
        const link = e.target && e.target.closest && e.target.closest("a[data-cart-toggle]");
        if (!link) return;
        link.setAttribute("href", currentPageCartHref());
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
          e.stopImmediatePropagation();
        }
      },
      true
    );
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      syncCartButtonHrefs();
      bindCartButtonNewTab();
      openRedirectedCartDrawer();
    });
  } else {
    syncCartButtonHrefs();
    bindCartButtonNewTab();
    openRedirectedCartDrawer();
  }

  // Keep "Shop the Collection" href in sync with the active Buyers favourites tab
  const syncTabsShopCollection = (holder) => {
    const shopLinks = holder.querySelectorAll("[data-tabs-shop-collection]");
    const currentTab = holder.querySelector(".tab-link.current[data-collection-url]");
    if (!shopLinks.length || !currentTab) return;
    const collectionUrl = currentTab.getAttribute("data-collection-url");
    if (!collectionUrl) return;
    shopLinks.forEach((shopLink) => shopLink.setAttribute("href", collectionUrl));
  };

  const initTabsShopCollection = () => {
    document.querySelectorAll("[data-tabs-holder]").forEach((holder) => {
      if (!holder.querySelector("[data-tabs-shop-collection]")) return;
      syncTabsShopCollection(holder);
      holder.addEventListener("theme:tab:change", () => syncTabsShopCollection(holder));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTabsShopCollection);
  } else {
    initTabsShopCollection();
  }

  // product page
  if (window.location.pathname.indexOf("/products/") != -1) {
    // open the fit tab if clicking the fit button, and scroll down
    let fitBtns = document.querySelectorAll(".find-your-fit");
    if (fitBtns.length) {
      fitBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          let fitTab = document.querySelector(
            ".product-tabs .tab-link.tab-link-2"
          );
          fitTab.click();
          fitTab.scrollIntoView({ behavior: "smooth" });
        });
      });
    }

    // set the default membership type
    if (document.querySelector(".purchase-type-box.membership")) {
      purchaseType = "membership";
    } else if (document.querySelector(".purchase-type-box.rental")) {
      purchaseType = "rental";
    }

    // if we're on a product page, set the default purchase type
    // and then show and hide elements based on change of purchase type
    let radios = document.querySelectorAll(
      'input[type="radio"][name="purchase-type"]'
    );
    if (radios.length) {
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          purchaseType = e.target.value;
          updateMembershipSelection();
        });
      });
      updateMembershipSelection();
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function updateMembershipSelection() {
  let hideMe = document.querySelectorAll(
    ".purchase-type-box:not(." + purchaseType + ") .inner"
  );
  if (hideMe.length) {
    hideMe.forEach((hide) => {
      hide.style.display = "none";
    });
  }
  document.querySelector(
    ".purchase-type-box." + purchaseType + " .inner"
  ).style.display = "block";
  document.querySelector(
    'input[type="radio"][name="purchase-type"][value="' + purchaseType + '"]'
  ).checked = true;
}

// on every page, we want to change the membership button in the nav
// to go to the supercycle membership page
// document.addEventListener("DOMContentLoaded", () => window.supercycle.state.subscribe(updateGlobalMembershipStates));
// function updateGlobalMembershipStates(state) {
//   const hasMembership = state.activeCreditAllowance > 0;
//   if (hasMembership && typeof ShopifyAnalytics.meta.page.customerId != 'undefined') {
//     let menuItem = document.querySelectorAll('.header__menu .menu__item a[href*="apps/supercycle/plans"]');
//     if (menuItem.length) {
//       menuItem[0].href = '/apps/supercycle';
//     }
//   }
// }

class CustomSort extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll("label").forEach((label) => {
      label.addEventListener("click", (e) => {
        e.preventDefault();

        const inputId = label.getAttribute("for");
        const input = this.querySelector(`#${inputId}`);
        if (!input) return;

        this.querySelectorAll('input[type="checkbox"]').forEach((i) => {
          i.checked = false;
        });

        input.checked = true;

        const newSortBy = input.value;
        const url = new URL(window.location.href);

        url.searchParams.set("sort_by", newSortBy);

        window.location.href = url.toString();
      });
    });
  }
}

customElements.define("custom-sort", CustomSort);

/*
 * Feedback 28.15: permanently pin .header-sections (Lipscore + nav).
 * Layout also inlines fixed styles + spacer; this keeps height in sync.
 */
(function () {
  const header =
    document.getElementById("ftc-site-header") ||
    document.querySelector(".header-sections");
  const spacer = document.getElementById("ftc-header-spacer");
  if (!header) return;

  function syncHeight() {
    const height = Math.ceil(header.getBoundingClientRect().height);
    if (!height) return;
    if (spacer) spacer.style.height = height + "px";
    document.documentElement.style.setProperty(
      "--ftc-pinned-header-height",
      height + "px"
    );
    document.documentElement.style.setProperty("--header-height", height + "px");
  }

  document.body.classList.add("has-header-sticky");
  header.classList.add("is-header-pinned");
  header.style.setProperty("position", "fixed", "important");
  header.style.setProperty("top", "0", "important");
  header.style.setProperty("z-index", "99999", "important");

  syncHeight();

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(syncHeight).observe(header);
  }
  window.addEventListener("resize", syncHeight);
  window.addEventListener("orientationchange", syncHeight);
  document.addEventListener("theme:resize", syncHeight);
  window.addEventListener("load", syncHeight);
  setTimeout(syncHeight, 300);
  setTimeout(syncHeight, 1000);
})();

/*
 * Feedback 28.16: Chrome mobile long-press can pan the document sideways
 * (or drag images) and leave the page off-screen. Keep window.scrollX at 0
 * unless the gesture is inside a real horizontal scroller.
 */
(function () {
  let startX = 0;
  let startY = 0;

  function isHorizontalScroller(el) {
    while (el && el !== document.documentElement) {
      if (el.nodeType === 1) {
        const style = window.getComputedStyle(el);
        const ox = style.overflowX;
        if (
          (ox === "auto" || ox === "scroll" || ox === "overlay") &&
          el.scrollWidth > el.clientWidth + 1
        ) {
          return true;
        }
        if (el.classList.contains("flickity-enabled")) return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  document.addEventListener(
    "touchstart",
    function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    function (e) {
      if (e.touches.length !== 1) return;
      if (window.scrollX !== 0) {
        window.scrollTo(0, window.scrollY);
      }
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) <= 10 || Math.abs(dx) <= Math.abs(dy)) return;
      if (isHorizontalScroller(e.target)) return;
      if (e.cancelable) e.preventDefault();
      if (window.scrollX !== 0) window.scrollTo(0, window.scrollY);
    },
    { passive: false }
  );

  window.addEventListener(
    "scroll",
    function () {
      if (window.scrollX !== 0) window.scrollTo(0, window.scrollY);
    },
    { passive: true }
  );
})();

(function initCartAppRefresh() {
  // Gift apps (Fokkio) write to the cart themselves. The drawer only re-renders
  // after its own add-to-cart, so an app-added gift stays invisible until the next
  // page load. Watch for cart writes and re-render when the drawer has gone stale.
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  let timer = null;

  const drawerItemCount = () => {
    const el = document.querySelector(".drawer__head-title__count");
    if (!el) return null;
    const count = parseInt(String(el.textContent).replace(/[^\d]/g, ""), 10);
    return Number.isNaN(count) ? null : count;
  };

  const refreshIfStale = () => {
    const cart = window.cart;
    if (!cart || typeof cart.getCart !== "function") return;
    if (!document.querySelector("[data-cart-drawer]")) return;

    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((data) => {
        // The header count is rendered from the cart, so a mismatch means the
        // drawer is showing a cart that no longer matches Shopify's. Re-rendering
        // only on a mismatch keeps the theme's own add-to-cart from flickering.
        const shown = drawerItemCount();
        if (shown !== null && shown === data.item_count) return;

        cart.getCart();
        if (typeof cart.updateSections === "function") cart.updateSections();
      })
      .catch(() => {});
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(refreshIfStale, 500);
  };

  const isCartWrite = (url) => {
    try {
      return CART_WRITE.test(String(url));
    } catch (error) {
      return false;
    }
  };

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const result = nativeFetch.apply(this, arguments);
      if (isCartWrite(url) && result && typeof result.then === "function") {
        result
          .then((response) => {
            if (response && response.ok) schedule();
          })
          .catch(() => {});
      }
      return result;
    };
  }

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ftcCartWrite = isCartWrite(url);
    return nativeOpen.apply(this, arguments);
  };

  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__ftcCartWrite) {
      this.addEventListener("load", function () {
        if (this.status >= 200 && this.status < 300) schedule();
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();

(function bridgeGiftAppToCartDrawer() {
  // Fokkio's JSON strategy ends with `callback ? callback(body) : window.location.reload()`,
  // so with no callback every gift add reloads the whole page. Supplying the
  // callbacks swaps that reload for an in-place drawer refresh.
  const refresh = () => {
    const cart = window.cart;
    if (!cart || typeof cart.getCart !== "function") {
      // Without the drawer instance we cannot re-render, so keep their reload.
      window.location.reload();
      return;
    }
    cart.getCart();
    if (typeof cart.updateSections === "function") cart.updateSections();
  };

  const hooks = {
    afterAddingToCart: refresh,
    afterAddingToCartOnCartPage: refresh,
    afterAddingToCartOnProductPage: refresh,
    afterRemoving: refresh,
    afterRemovingOnCartPage: refresh,
    afterRemovingOnProductPage: refresh,
  };

  let value = Object.assign({}, window.FokkioCustom, hooks);

  try {
    Object.defineProperty(window, "FokkioCustom", {
      configurable: true,
      enumerable: true,
      get() {
        return value;
      },
      set(next) {
        // The app runs its own custom code through new Function(), which assigns
        // window.FokkioCustom outright. Merge so their settings survive and our
        // callbacks are not lost, whichever order the scripts run in.
        value = Object.assign({}, next, hooks);
      },
    });
  } catch (error) {
    window.FokkioCustom = value;
  }
})();

(function initMembershipGiftSync() {
  // Fokkio only evaluates its promotion on a later page load, so a qualifying
  // membership leaves the customer with no gift until they navigate again. Drive
  // the promotion from the theme instead, reading Fokkio's own config so the
  // trigger and the gift stay editable in their admin rather than hardcoded here.
  const GIFT_PROPERTY = "_fokkio_gift";
  let syncing = false;
  let queued = false;
  let timer = null;

  const numericId = (gid) => {
    const id = parseInt(String(gid).split("/").pop(), 10);
    return Number.isNaN(id) ? null : id;
  };

  const activePromotions = () => {
    const state = window.FokkioShopSurprise;
    const promotions = (state && state.promotions) || [];
    return promotions.filter(
      (promotion) =>
        promotion &&
        promotion.status === "active" &&
        promotion.type === "add_product_to_cart"
    );
  };

  const triggersOf = (promotion) => {
    const group = promotion.trigger_group;
    if (!group || !group.triggers) return [];
    return Array.isArray(group.triggers) ? group.triggers : [group.triggers];
  };

  const giftVariants = (promotion) =>
    ((promotion.action && promotion.action.variants) || [])
      .map((variant) => ({
        id: numericId(variant.id),
        quantity: variant.quantity || 1,
      }))
      .filter((variant) => variant.id);

  // Only SELLING_PLANS triggers are enforced here. Anything else is left to
  // Fokkio, so an unfamiliar promotion is never applied on a guess.
  const canEvaluate = (promotion) => {
    const triggers = triggersOf(promotion);
    return (
      triggers.length > 0 &&
      triggers.every((trigger) => trigger && trigger.type === "SELLING_PLANS")
    );
  };

  const cartQualifies = (cart, promotion) =>
    triggersOf(promotion).every((trigger) => {
      const planIds = new Set(
        (trigger.sellingPlans || []).map((plan) => String(numericId(plan.id)))
      );
      const matched = (cart.items || []).reduce((total, item) => {
        const allocation = item.selling_plan_allocation;
        const planId =
          allocation && allocation.selling_plan
            ? String(allocation.selling_plan.id)
            : null;
        return planId && planIds.has(planId) ? total + item.quantity : total;
      }, 0);

      const needed = parseInt(trigger.quantity, 10) || 1;
      if (trigger.operator === "LESS_OR_EQUAL") return matched <= needed;
      if (trigger.operator === "EQUAL") return matched === needed;
      return matched >= needed;
    });

  const cartLinesFor = (cart, variantId) =>
    (cart.items || []).filter((item) => item.variant_id === variantId);

  const readCart = () =>
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then(
      (response) => response.json()
    );

  const addGift = (variant) =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity: variant.quantity,
            properties: { [GIFT_PROPERTY]: "true" },
          },
        ],
      }),
    });

  const removeLine = (line) =>
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });

  const redrawDrawer = () => {
    const cart = window.cart;
    if (!cart || typeof cart.getCart !== "function") return;
    cart.getCart();
    if (typeof cart.updateSections === "function") cart.updateSections();
  };

  const sync = async () => {
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;

    try {
      const promotions = activePromotions().filter(canEvaluate);
      if (!promotions.length) return;

      let cart = await readCart();
      let changed = false;

      for (const promotion of promotions) {
        const qualifies = cartQualifies(cart, promotion);

        for (const variant of giftVariants(promotion)) {
          const lines = cartLinesFor(cart, variant.id);

          if (qualifies && lines.length === 0) {
            await addGift(variant);
            changed = true;
          } else if (!qualifies && lines.length > 0) {
            // The gift product exists only to be given away, so any line of it
            // belongs to the promotion and should go when the cart stops qualifying.
            for (const line of lines) await removeLine(line);
            changed = true;
          }
        }

        if (changed) cart = await readCart();
      }

      if (changed) redrawDrawer();
    } catch (error) {
      console.error("Gift sync failed", error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        sync();
      }
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, 300);
  };

  ["theme:cart:change", "theme:product:added"].forEach((eventName) => {
    document.addEventListener(eventName, schedule);
  });

  // The membership flow redirects to a collection page, so the gift is usually
  // resolved on the page that loads after the redirect rather than in place.
  const start = () => window.setTimeout(sync, 600);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
